import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'profile',
    templateUrl: './profile.component.html'
})

export class ProfileComponent {
    constructor(public router: Router) { }
}
